import { z } from 'zod'
import type { ApiClient } from '../apiClient'

// PostgREST returns a bare string array for this RPC (not the SETOF-scalar object-wrap).
const kpisForPageSchema = z.array(z.string())

export async function getKpisForPage(client: ApiClient, page: string): Promise<string[]> {
  const raw = await client.rpc<unknown>('get_kpis_for_page', { p_page: page })
  return kpisForPageSchema.parse(raw)
}
